// Define mobile/tablet devices from list with options
// eslint-disable-next-line
export const regExpMobileDevices = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
// Define any characters other than letters, numbers and underscore
export const regExpAnyCharacters = /[^\w]+/g;
// Define all spaces
export const regExpSpaces = /(\s+)/g;
// eslint-disable-next-line no-control-regex,max-len
export const regExpValidationEmail = /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9][A-Za-z0-9-]*([.][A-Za-z0-9-]+)*\.[A-Za-z]{2,10}\b$/i;
export const reqExpNumber = /^\+?\d+$/;
export const regExpOnlyNumbers = /^\d+$/;
export const reqExpContainsNumbers = /\d/;
export const reqExpHasExternalUrl = /(htt[p|ps])\S*|(www)\.\S*/i;
export const reqExpHasTel = /tel:/i;
export const reqExpHasMailTo = /mailto:/i;
export const regExpCertificateCode = /^[A-Za-z]\d{11}$/;
export const regExpRedemptionCode = /^[a-z\d]{6}$/;
export const regExpNewLine = /(\r\n|\n|\r)/gm;
export const regExpSpecialCharacters = /[-[\]{}()*+?.,\\^$|#]/g;
export const regExpNotLettersOrNumbers = /[^a-zA-Z0-9 ]/g;
